module.exports = __webpack_public_path__ + "./docs/img/icon-constants.6db069e3c9a476d68d4e0cd6d95fb918.svg";